import { render } from "./ReservationComponent.vue?vue&type=template&id=4c93f4fa&scoped=true"
import script from "./ReservationComponent.vue?vue&type=script&lang=js"
export * from "./ReservationComponent.vue?vue&type=script&lang=js"

import "./ReservationComponent.vue?vue&type=style&index=0&id=4c93f4fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c93f4fa"]])

export default __exports__